import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['submit', 'input', 'clear'];

  initialize() {
    this.updateFormState();
  }

  updateFormState() {
    const val = (this.inputTarget.value || '').trim();

    this.submitTarget.disabled = val.length < 2;
    this.clearTarget.classList.toggle('d-none', !val.length);
  }

  clearSearchField() {
    this.inputTarget.value = '';
    this.inputTarget.focus();
    this.updateFormState();
  }
}
